import { useAuthStore } from '@/stores/auth';
import { demoRequest } from './demo';

interface ApiOptions extends Omit<RequestInit, 'body'> {
  body?: unknown;
  anonymous?: boolean;
}

export async function api<T>(path: string, options: ApiOptions = {}): Promise<T> {
  if (import.meta.env.VITE_DEMO_MODE === 'true') return demoRequest<T>(path, { method: options.method, body: options.body });
  const auth = options.anonymous ? null : useAuthStore();
  const headers = new Headers(options.headers);
  if (auth?.token) headers.set('authorization', `Bearer ${auth.token}`);
  let body: BodyInit | undefined;
  if (options.body instanceof FormData) body = options.body;
  else if (options.body !== undefined) { headers.set('content-type', 'application/json'); body = JSON.stringify(options.body); }
  const response = await fetch(`/api${path}`, { ...options, headers, body });
  const payload = await response.json().catch(() => ({})) as { message?: string };
  if (response.status === 401 && auth) auth.logout();
  if (!response.ok) throw new Error(payload.message || `请求失败（${response.status}）`);
  return payload as T;
}
